import { Icons } from "@caspeco/casper-ui-library";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import { useTranslation } from "react-i18next";
import ErrorTemplate from "./error-template";

export default function BrokenLink() {
    const { t } = useTranslation();

    usePageTracking({
        pageName: "BrokenLinkError",
        pageType: PageType.Page,
    });

    return (
        <ErrorTemplate
            icon={Icons.LinkBroken}
            title={t("errorInformation.brokenLink")}
            message={t("errorInformation.brokenLinkText")}
        />
    );
}
